import { GET_LIST, GET_MANY } from 'react-admin';

const getAchTiersList = ({ response, url, options, httpClient, params, apiUrl }) => {
  const data = response.json;

  return {
    ...response,
    json: data.map((tier) => ({
      ...tier,
      id: tier.tier,
    })),
  };
};

export default {
  [GET_LIST]: getAchTiersList,
  [GET_MANY]: getAchTiersList,
};
